/**
 * Collection titles — drop + expand on scroll (down & up)
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SELECTORS = [
    '#MainContent .section-resource-list__header .text-block',
    '#MainContent .product-list-header .text-block',
    '#MainContent [class*="product-list"] .text-block',
    '#MainContent .collection-list .text-block:is(.h1, .h2, .h3, .h4, .rte)',
    '#MainContent .drip-collection-carousel__heading',
    '#MainContent [data-drip-title]',
  ].join(',');

  function plainText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function openTitle(el, shell) {
    if (el.__dripTitleOpen) return;
    el.__dripTitleOpen = true;
    clearTimeout(el.__dripTitleCloseT);

    el.classList.add('is-in');
    shell.classList.add('is-dropped');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.__dripTitleOpen) shell.classList.add('is-expanded');
      });
    });
  }

  function closeTitle(el, shell) {
    if (!el.__dripTitleOpen && !shell.classList.contains('is-dropped')) return;
    el.__dripTitleOpen = false;

    // Shrink first, then lift
    shell.classList.remove('is-expanded');
    el.classList.remove('is-in');

    clearTimeout(el.__dripTitleCloseT);
    el.__dripTitleCloseT = setTimeout(function () {
      if (!el.__dripTitleOpen) shell.classList.remove('is-dropped');
    }, 320);
  }

  function wrapTitle(el) {
    if (el.dataset.dripTitleFx === '1') return el.querySelector('.drip-title-island');

    var full = plainText(el);
    if (!full || full.length < 2) return null;
    if (el.closest('.product-card, .resource-list__item, predictive-search, .hero')) return null;

    el.dataset.dripTitleFx = '1';
    el.classList.add('drip-title-fx');

    el.querySelectorAll('[hidden]').forEach(function (n) {
      n.removeAttribute('hidden');
      n.removeAttribute('aria-hidden');
    });
    el.querySelectorAll('.drip-morph, .drip-morph-sr').forEach(function (n) {
      n.remove();
    });
    el.classList.remove('drip-morph-host');

    var shell = document.createElement('span');
    shell.className = 'drip-title-island';
    shell.setAttribute('aria-hidden', 'true');

    var label = document.createElement('span');
    label.className = 'drip-title-island__label';
    label.textContent = full;
    shell.appendChild(label);

    var sr = document.createElement('span');
    sr.className = 'drip-title-sr';
    while (el.firstChild) sr.appendChild(el.firstChild);
    el.appendChild(sr);
    el.appendChild(shell);

    return shell;
  }

  function enhance(el) {
    var shell = wrapTitle(el);
    if (!shell) return;

    if (REDUCE) {
      el.__dripTitleOpen = true;
      el.classList.add('is-in');
      shell.classList.add('is-dropped', 'is-expanded');
      return;
    }

    if (el.__dripTitleIO) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          if (visible) openTitle(el, shell);
          else closeTitle(el, shell);
        });
      },
      { threshold: [0, 0.15, 0.35, 0.6], rootMargin: '8% 0px -6% 0px' }
    );

    io.observe(el);
    el.__dripTitleIO = io;

    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || 800;
    if (rect.top < vh * 0.82 && rect.bottom > vh * 0.12) {
      openTitle(el, shell);
    }
  }

  function scan(scope) {
    var root = scope || document;
    root.querySelectorAll(SELECTORS).forEach(enhance);

    root.querySelectorAll('#MainContent .text-block').forEach(function (el) {
      if (el.closest('.hero, .product-card')) return;
      var t = plainText(el).toUpperCase();
      if (
        /MOST WANTED|NEW DROP|SHOP THE COLLECTION|WANTED/.test(t) ||
        (el.closest('.section-resource-list__header, [class*="product-list"]') && t.length < 48)
      ) {
        enhance(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', function () {
    setTimeout(scan, 120);
  });
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
